import { Disclosure } from "@headlessui/react";
import { BellIcon } from "@heroicons/react/outline";
// import { Icon } from "@iconify/react";
import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

//context
import AuthContext from "../../context/AuthContext";
import ScrollingContext from "../../context/ScrollingContext";
import ThemeContext from "../../context/ThemeContext";

//ui
import ShowingTransition from "../../components/ui/ShowingTransition";

//navs
import DarkmodeButton from "./components/DarkmodeButton";
import NavbarMenu from "./components/NavbarMenu";
import NavbarMenuItem from "./components/NavbarMenuItem";
import NavbarNotification from "./components/NavbarNotification";
import NavbarRow from "./components/NavbarRow";
import ProgressBar from "./components/ProgressBar";

//navs-assets

// import logo from "../../assets/navbar/logo.png";
import userIcon from "../../assets/navbar/user.png";
import "./navbar.css";
// import CenterIcon from "../../components/ui/CenterIcon";
import {
    adminPanelColor,
    adminPath,
    isChargeInsertAuto,
    isCommunity,
    isNavBarNotification,
    isSearch,
    isStoreLocatorAvailable,
    isStudyPlannerEnabled,
    isWalletEnabled,
    navbarDisclosureColor,
    navbarIconColor,
    teachersubadminPath,
} from "../../services/defaultSettings";

import CelebrateNotifiction from "./components/CelebrateNotifiction";
import ValidNameCheck from "./components/ValidNameCheck";
import {
    DisclosureLoginComponent,
    DisclosureRegisterComponent,
    navbarClassName,
    NavbarLinksComponent,
    NavbarLoginComponent,
    NavbarRegisterComponent,
    navLogoComponent,
} from "../../services/navbarChangableComponents";
import CenterIcon from "../../components/ui/CenterIcon";
import { printUnit } from "../../utils/ar";
import MainNotification from "./components/MainNotification";
import { NotificationProvider } from "../../context/NotificationContext";
import NotificationsIcon from "./NotificationsIcon";
import SearchComponent from "./SearchComponent";
import TempNotifcation from "./components/TempNotifcation";
import { useWeek } from "../../hooks/useWeek";
import { useLanguage } from "../../context/LanguageContext";
import LanguageSwitch from "./components/LanguageSwitch";
import DisclosureLink from "./components/DisclosureLink";

const Navbar = () => {
    let { token: authToken, user, adminToken: isAdmin, currentBalance } = useContext(AuthContext);
    let { isRTL, darkmode, isOpen, toggleSideNav } = useContext(ThemeContext);
    let { scrolling } = useContext(ScrollingContext);
    let { WeeksFound } = useWeek();
    const [isAdminPath, setIsAdminPath] = useState(false);
    const { language, switchLanguage } = useLanguage();

    // Inline translations
    const content = {
        login: {
            en: "Login Now",
            ar: "سجل دخولك",
            de: "Jetzt anmelden",
        },
        register: {
            en: "New Account",
            ar: "حساب جديد",
            de: "Registrieren",
        },
        linksMenu: {
            home: {
                en: "Home",
                ar: "الرئيسية",
                de: "Startseite",
            },
            aboutUs: {
                en: "About Us",
                ar: "من نحن !",
                de: "Über uns",
            },
            careers: {
                en: "Careers",
                ar: "وظائف",
                de: "Karriere",
            },
        },
        altLogin: {
            en: "Login with your account",
            ar: "سجل الدخول لحسابك",
            de: "Melden Sie sich mit Ihrem Konto an",
        },
        altRegister: {
            en: "Create a free account",
            ar: "انشئ حساب مجاني.",
            de: "Erstellen Sie ein kostenloses Konto",
        },
        menu: {
            home: {
                en: "Home",
                ar: "الصفحة الرئيسية",
                de: "Startseite",
            },
            study: {
                en: "My Study",
                ar: "مذاكرتي",
                de: "Mein Studium",
            },
            welcome: {
                en: "Welcome",
                ar: "أهلاً",
                de: "Willkommen",
            },
            rechargeCode: {
                en: "Recharge Code",
                ar: "شحن كود سنتر",
                de: "Aufladecode",
            },
            myAccount: {
                en: "My Account",
                ar: "حسابي",
                de: "Mein Konto",
            },
            wallet: {
                en: "My Wallet",
                ar: "محفظتي",
                de: "Meine Brieftasche",
            },
            myCourses: {
                en: "My Courses",
                ar: "كورساتي",
                de: "Meine Kurse",
            },
            community: {
                en: "Student Forum",
                ar: "منتدى الطلبة",
                de: "Studentenforum",
            },
            storeLocator: {
                en: "Book & Code Outlets",
                ar: "منافذ بيع الكتب و الأكواد",
                de: "Buch- und Codeverkaufsstellen",
            },
            logout: {
                en: "Logout",
                ar: "تسجيل خروج",
                de: "Abmelden",
            },
        },
    };
    const location = useLocation();

    let isNavbarHidden = false;

    if ((location.pathname === "/" || location.pathname === "/home") && scrolling < 1) {
        isNavbarHidden = true;
    }

    const [className, setClassName] = useState("");
    useEffect(() => {
        if (
            location.pathname.includes(adminPath) ||
            location.pathname.includes(teachersubadminPath)
        ) {
            setClassName("negative-nav-margin");
            setIsAdminPath(true);
        } else {
            setClassName("");
            setIsAdminPath(false);
        }
    }, [location.pathname]);
    useEffect(() => {
        if (!location.pathname.includes("questions")) {
            window.scrollTo(0, 0);
        }
    }, [location.pathname]);
    let disclosureColorClassName;
    switch (navbarDisclosureColor) {
        case "rose":
            disclosureColorClassName = ` bg-rose-600 `;
            break;
        case "cyan":
            disclosureColorClassName = ` bg-cyan-600 `;
            break;
        case "emerald":
            disclosureColorClassName = ` bg-emerald-600 `;
            break;
        case "yellow":
            disclosureColorClassName = ` bg-yellow-300 `;
            break;
        case "teal":
            disclosureColorClassName = ` bg-teal-600 `;
            break;
        case "sky":
            disclosureColorClassName = ` bg-sky-600 `;
            break;
        case "ashGray":
            disclosureColorClassName = ` bg-ashGray-600 `;
            break;
        case "germanRed":
            disclosureColorClassName = ` bg-germanRed-600 `;
            break;
        default:
            disclosureColorClassName = `bg-blue-600`;
            break;
    }

    let adminPanelIconColor;
    switch (adminPanelColor) {
        case "yellow":
            adminPanelIconColor = ` bg-yellow-600 dark:bg-yellow-300 hover:bg-yellow-500 dark:hover:bg-yellow-500 text-yellow-100 dark:text-slate-900 `;
            break;
        case "rose":
            adminPanelIconColor = ` bg-rose-600 dark:bg-rose-600 hover:bg-rose-500 dark:hover:bg-rose-500 dark:text-rose-100 text-rose-100 `;
            break;
        case "emerald":
            adminPanelIconColor = ` bg-emerald-600 dark:bg-emerald-600 hover:bg-emerald-500 dark:hover:bg-emerald-500 dark:text-emerald-100 text-emerald-100`;
            break;
        case "cyan":
            adminPanelIconColor = ` bg-cyan-600 dark:bg-cyan-600 hover:bg-cyan-500 dark:hover:bg-cyan-500 dark:text-cyan-100 text-cyan-100 `;
            break;
        case "teal":
            adminPanelIconColor = `bg-teal-600 dark:bg-teal-600 hover:bg-teal-500 dark:hover:bg-teal-500 dark:text-teal-100 text-teal-100"`;
            break;
        case "ashGray":
            adminPanelIconColor = `bg-ashGray-600 dark:bg-ashGray-600 hover:bg-ashGray-500 dark:hover:bg-ashGray-500 dark:text-ashGray-100 text-ashGray-100"`;
            break;
        default:
            adminPanelIconColor = `bg-blue-600 dark:bg-blue-600 hover:bg-blue-500 dark:hover:bg-blue-500 dark:text-blue-100 text-blue-100 smooth`;
            break;
    }

    return (
        <Disclosure
            as="nav"
            className={`${className} rtl navbar z-40 fixed inset-0 bottom-auto smooth ${navbarClassName(
                isNavbarHidden,
                isRTL,
                scrolling
            )}`}
        >
            {({ open }) => (
                <>
                    <ValidNameCheck />
                    <MainNotification />
                    <TempNotifcation />
                    <div className="relative h-full">
                        <ProgressBar />
                        <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 h-full">
                            <div className="relative flex items-center justify-between h-full flex-row-reverse">
                                {!authToken && (
                                    <div className="navbar-collapse-button absolute inset-y-0 left-0 flex items-center md:hidden">
                                        {/* Mobile menu button*/}
                                        <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white ar">
                                            <span className="sr-only">Open main menu</span>
                                            <div
                                                id="nav-icon"
                                                className={`${navbarIconColor} ${
                                                    open ? " open" : ""
                                                }`}
                                            >
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </Disclosure.Button>
                                    </div>
                                )}

                                {/* <DarkmodeButton
                                    className={`block md:hidden absolute ${
                                        authToken ? "left-0" : "right-0"
                                    }`}
                                /> */}
                                <LanguageSwitch
                                    className={`block md:hidden absolute ${
                                        authToken ? "left-0" : "right-0"
                                    }`}
                                />
                                {isSearch ? (
                                    <SearchComponent
                                        className={`block md:hidden absolute ${
                                            authToken ? "left-24" : "right-20"
                                        }`}
                                        isLargeScreen={false}
                                    />
                                ) : (
                                    ""
                                )}
                                {/* {isSearch ? <SearchComponent className={"block md:hidden"} /> : ""} */}
                                {isAdminPath && isAdmin && (
                                    <div className="absolute top-navbar-height right-0 flex-center-both pt-2">
                                        <div
                                            className={`flex lg:hidden flex-row items-center justify-start cursor-pointer rounded-md py-3 group px-2 z-1000 ${adminPanelIconColor}`}
                                            onClick={toggleSideNav}
                                        >
                                            <div className={`w-10 flex-center-both font-h2`}>
                                                <CenterIcon
                                                    icon={"bi:arrow-left-circle-fill"}
                                                    nY="0"
                                                    className={`smooth  ${
                                                        isOpen ? "rotate-180" : ""
                                                    }`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <NavbarRow
                                    isCentered={false}
                                    className="navbar-brand-container flex-1 md:flex-none flex items-center justify-center md:items-center md:justify-end h-full"
                                >
                                    {/* <DarkmodeButton className="hidden md:block" /> */}
                                    <LanguageSwitch className="hidden md:block" />
                                    <div className="navbar-brand flex-shrink-0 flex items-center">
                                        <Link to="/">{navLogoComponent(darkmode)}</Link>
                                    </div>
                                </NavbarRow>
                                {!authToken && (
                                    <NavbarRow
                                        isCentered={true}
                                        className="md:basis-1/2 basis-0 hidden md:flex items-center justify-center h-full"
                                    >
                                        <NavbarLinksComponent
                                            content={content.linksMenu}
                                            language={language}
                                        />
                                    </NavbarRow>
                                )}

                                <div
                                    className={`absolute inset-y-0 right-0 flex items-center pr-2 md:static md:inset-auto sm:pr-0 sm:ml-6`}
                                >
                                    {!authToken && (
                                        <div className="md:block hidden mr-16 lg:mr-0">
                                            <NavbarRow className="space-x-4 rtl">
                                                <NavbarLoginComponent
                                                    content={content.login[language]}
                                                    isRTL={isRTL}
                                                />
                                                <NavbarRegisterComponent
                                                    content={content.register[language]}
                                                />
                                            </NavbarRow>
                                        </div>
                                    )}
                                    {authToken && (
                                        <>
                                            <NavbarRow isRTL={isRTL} className="space-x-2">
                                                <NavbarMenu
                                                    menuButton={
                                                        <div className="overflow-hidden">
                                                            <span className="sr-only">
                                                                Open user menu
                                                            </span>
                                                            <img
                                                                className="h-12 w-auto  rounded-full"
                                                                src={userIcon}
                                                                alt=""
                                                            />
                                                        </div>
                                                    }
                                                    menuButtonClassName={"rounded-full"}
                                                    menuItems={
                                                        <>
                                                            <NavbarMenuItem
                                                                icon="ic:twotone-home"
                                                                to="/"
                                                                text={content.menu.home[language]}
                                                            />
                                                            {isStudyPlannerEnabled &&
                                                                WeeksFound > 0 && (
                                                                    <NavbarMenuItem
                                                                        icon="guidance:study-room"
                                                                        to="/my-study"
                                                                        text={
                                                                            content.menu.study[
                                                                                language
                                                                            ]
                                                                        }
                                                                    />
                                                                )}
                                                            <div className="w-full px-4">
                                                                <div className="h-1 bg-secondary-container smooth w-full rounded-md"></div>
                                                            </div>
                                                            <NavbarMenuItem
                                                                to="/me/user/"
                                                                text={`${
                                                                    content.menu.welcome[language]
                                                                } ${user && user.full_name}`}
                                                            />
                                                            {isChargeInsertAuto && (
                                                                <NavbarMenuItem
                                                                    icon="ri:qr-scan-line"
                                                                    to="/me/user/charge_insert_auto"
                                                                    text={
                                                                        content.menu.rechargeCode[
                                                                            language
                                                                        ]
                                                                    }
                                                                />
                                                            )}
                                                            <NavbarMenuItem
                                                                icon="carbon:user-avatar-filled"
                                                                to="/me/user/"
                                                                text={
                                                                    content.menu.myAccount[language]
                                                                }
                                                            />
                                                            {isWalletEnabled && (
                                                                <NavbarMenuItem
                                                                    icon="solar:wallet-bold-duotone"
                                                                    to="/me/user/wallet"
                                                                    text={
                                                                        content.menu.wallet[
                                                                            language
                                                                        ]
                                                                    }
                                                                />
                                                            )}
                                                            <NavbarMenuItem
                                                                icon="ph:book-open-duotone"
                                                                to="/me/user/courses"
                                                                text={
                                                                    content.menu.myCourses[language]
                                                                }
                                                            />
                                                            {isCommunity && (
                                                                <NavbarMenuItem
                                                                    icon="ic:twotone-group"
                                                                    to="/community"
                                                                    text={
                                                                        content.menu.community[
                                                                            language
                                                                        ]
                                                                    }
                                                                />
                                                            )}
                                                            {isStoreLocatorAvailable && (
                                                                <NavbarMenuItem
                                                                    icon="ph:storefront-duotone"
                                                                    to="/store_locator"
                                                                    text={
                                                                        content.menu.storeLocator[
                                                                            language
                                                                        ]
                                                                    }
                                                                />
                                                            )}
                                                            <NavbarMenuItem
                                                                icon="icomoon-free:exit"
                                                                to="/logout"
                                                                text={content.menu.logout[language]}
                                                            />
                                                        </>
                                                    }
                                                />
                                                {isNavBarNotification && (
                                                    <NotificationProvider>
                                                        <NavbarMenu
                                                            containerClassName=""
                                                            menuButton={
                                                                <>
                                                                    {/* <span className="sr-only">
                                                                    View notifications
                                                                </span>
                                                                <BellIcon className="h-6 w-6" /> */}
                                                                    <NotificationsIcon />
                                                                </>
                                                            }
                                                            menuButtonClassName={""}
                                                            menuItems={
                                                                <>
                                                                    <NavbarNotification />
                                                                </>
                                                            }
                                                        />
                                                    </NotificationProvider>
                                                )}
                                                {isWalletEnabled ? (
                                                    <Link to="/me/user/wallet">
                                                        <div className="">
                                                            <div className="rounded-full bg-slate-900 dark:bg-slate-100 smooth flex flex-row flex-center-both overflow-hidden">
                                                                <div className="text-slate-100 font-h3 bg-slate-500 dark:text-slate-900 smooth rounded-full md:px-2 md:py-2 py-2 px-1">
                                                                    <CenterIcon
                                                                        icon={
                                                                            "solar:wallet-bold-duotone"
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className="text-slate-100 dark:text-slate-900 smooth md:pb-0.5 font-small md:px-2 px-1">
                                                                    {printUnit(
                                                                        currentBalance,
                                                                        "جنيه"
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                ) : (
                                                    ""
                                                )}
                                            </NavbarRow>
                                        </>
                                    )}
                                    {isSearch ? (
                                        <SearchComponent className={"hidden md:block"} />
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>

                        {!authToken && (
                            <ShowingTransition>
                                <Disclosure.Panel
                                    className={`${disclosureColorClassName} ${
                                        language !== "ar" ? "en" : "ar"
                                    }  text-white rounded-xl mt-1 md:hidden block `}
                                >
                                    <div className="px-4 pt-4 pb-5 space-y-4">
                                        <DisclosureRegisterComponent
                                            content={content.altRegister[language]}
                                        />
                                        <DisclosureLoginComponent
                                            content={content.altLogin[language]}
                                        />
                                        <DisclosureLink to="/about_us">
                                            <span className="flex-center-both gap-2">
                                                <CenterIcon icon="ix:about-filled" />
                                                {content.linksMenu.aboutUs[language]}
                                            </span>
                                        </DisclosureLink>
                                        <DisclosureLink to="/join_us">
                                            <span className="flex-center-both gap-2">
                                                <CenterIcon icon="hugeicons:job-search" />
                                                {content.linksMenu.careers[language]}
                                            </span>
                                        </DisclosureLink>
                                    </div>
                                </Disclosure.Panel>
                            </ShowingTransition>
                        )}
                    </div>
                    <CelebrateNotifiction />
                </>
            )}
        </Disclosure>
    );
};

export default Navbar;
